import { CloudDownload } from '@mui/icons-material'
import { Badge, Button } from '@mui/material'
import React from 'react'

import SupAttachmentDialog from './SupAttachmentDialog';
import { useState } from 'react';
import { useEffect } from 'react';

export default function SupAttachment({ onChange, item, onSave }) {

  const [open, setOpen] = useState(false)

  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (onSave) {
      setTouched(true);
    } else {
      setTouched(false);
    }

  }, [onSave]);

  const showError = item.isMandatory && touched && item?.attachments?.filter((x) => x.type === 0)?.length === 0;

  return (
    <div>
      <>
        <Badge badgeContent={item?.attachments?.filter((x) => x.type === 0)?.length} color="error">
          <Button size='small' onClick={() => setOpen(true)} variant='contained' endIcon={
            <CloudDownload />
          }>Attachments</Button>
        </Badge>
        <SupAttachmentDialog
          open={open}
          setOpen={setOpen}
          module={'Vendors'}
          value={item?.attachments}
          setValue={onChange}
          initialData={item?.attachments}
        />
      </>
      <div>
        {showError ? <span style={{ color: '#d32f2f' }}>This field is required</span> : <></>}
      </div>
    </div>
  );
}